import { getConfig } from '@chegg-web-tools/config-plugin';
import { createClient } from 'contentful';

export function getContentfulClient() {
  const isPreviewMode = window.location.search.includes('previewMode=true');
  const env = getConfig('env');
  const currentConfig =
    isPreviewMode && env == 'test' ? getConfig('contentfulPreview') : getConfig('contentful');
  const { host, environment, space, accessToken } = currentConfig;

  return createClient({
    host,
    space,
    environment,
    accessToken,
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getContentfulData<T>(query: any) {
  return getContentfulClient().getEntries<T>(query);
}
